export interface SearchItem {
  med_name: string;
  tel_area: string;
  name: string;
}

export const DefaultSearchItem = (): SearchItem => ({
  med_name: "",
  tel_area: "",
  name: ""
});

export interface SearchResList {
  id: number;
  med_name: string;
}

export interface AddItem {
  medId: number;
  last_name: string;
  last_name_kana: string;
  first_name: string;
  first_name_kana: string;
}

export const DefaultAddItem = (): AddItem => ({
  medId: 0,
  last_name: "",
  last_name_kana: "",
  first_name: "",
  first_name_kana: ""
});
